'use strict';

const _ = require('lodash');

/**
 * @name FacetRepositoryOptions
 * @type {Object}
 * @property {string} type
 * @property {String} placeTypeFacetName
 */

/**
 * ファセット検索連携して、マップアプリとしてデータ表示するためのデータベースアクセサ
 * 
 * @name FacetRepository
 * @extends {Repository}
 *
 * events:
 *   ihBeforeSearch     検索APIのアクセス前
 *   ihAfterSearch      検索APIのアクセス後
 *
 */
export default class FacetRepository {
  /**
   * 
   * @param {FacetRepositoryOptions} options
   */
  constructor(options) {
    this.events = null;
    this.options = options;
  }
  setEvents(events) {
    this.events = events;
  }
  /**
   * 
   * @param {Request} request
   * @returns {Promise}
   */
  search(request) {

    // 円表示なしの場合は、全て検索対象にする
    if (request.radius === '0' || request.radius === '' || request.radius === 0) {
      request.radius = 100;
    }

    this.events.emit('ihBeforeSearch', request);

    if (!this.facets) {
      return Promise.resolve({places: []});
    }

    var query = this.buildFacetQuery(request);

    return this.getFacetResult(query).then((result) => {

      result = _.filter(result, function (a) {
        return a.lat && a.lng;
      });

      if (request.opt.places) {
        result = _.filter(result, function (a) {
          return _.contains(request.opt.places, a.attributes.No + "");
        })
      }
      this.searchResult = {places: result};

      return this.searchResult;
    });
  }
  setFacets(facets) {
    // 保持しておく
    this.facets = facets;

    // 施設種別ファセットを探す
    var typeFacet;
    _.forEach(this.facets, (facet) => {
      if (facet.name === this.options.placeTypeFacetName) {
        typeFacet = facet;
      }
    });

    // 施設種別がすぐに取得できるように準備しておく
    if (typeFacet) {
      this.facility_type_name_table = _.reduce(typeFacet.items, (obj, item, i) => {
        obj[i] = item.name;
        return obj;
      }, {});
      this.facility_type_name_table_inverted = _.invert(this.facility_type_name_table);
    }
  }
  /**
   * 
   * @returns {Promise.<Facet[]>}
   */
  loadFacets() {
    var url = '../facet/api/facets';

    return $.ajax({url: url, dataType: 'json'}).then((facets) => {
      facets =  _.map(facets, (facet) => {
        try{
          facet.attributes = JSON.parse(facet.attributes);
        }catch(e){

        }
        return facet;
      });

      this.setFacets(facets);

      return facets;
    });
  }
  /**
   *
   * @returns {Promise.<Facet[]>}
   */
  getFacets() {
    
    if (this.facets) {
      return Promise.resolve(this.facets);
    }
    
    return this.loadFacets();
  }
  /**
   *
   * @param {Number} id
   * @return {Facet}
   */
  getFacetByItemId(id){
    return _.find(this.facets, function(facet){
      return _.find(facet.items, function(item){
        return item.id == id;
      });
    });
  }
  getFacetItemByItemId(id){
    const facet =  _.find(this.facets, function(facet){
      return _.find(facet.items, function(item){
        return item.id == id;
      });
    });
    return _.find(facet.items, function(item){
      return item.id == id;
    });
  }
  getFacetCount(params){
    var url = '../facet/api/count';
    return $.ajax({url: url, dataType: 'json', data: params}).then(function(result){
      return result;
    });
  }
  buildFacetQuery(request) {
    var that = this;
    if (!request || !request.opt){
      return {};
    }
    var types = request.opt.types || [];
    return types.reduce(function(q, type){
      var facet = that.getFacetByItemId(type);
      if (facet){
        if (!q[facet.id]){
          q[facet.id] = [];
        }
        q[facet.id].push(type);
      }
      return q;
    }, {});
  }
  /**
   *
   * @param params
   * @returns {Promise.<Document[]>}
   */
  getFacetResult(params) {
    var url = '../facet/api/query';
    var that = this;
    
    return new Promise((resolve, reject) => {
      
      $.ajax({url: url, dataType: 'json', data: params}).done((result) => {

        // ミュシャ カスタム検索用の並替え
        if ( /pickup/.test(that.sortKey) ) {
          result = that.sortResultMulti(result);
        } else {
          result = that.sortResult(result);
        }

        result = _.map(result, this.convertFromFacetResultItem.bind(this));
        
        resolve(result);
        
      })
      .fail((err) => {
        reject(err);
      })
      
    });
  }

  /**
   * ミュシャ カスタム検索用の2つの基準による並替え
   * 　並替え優先値 -> 制作年の順
   * 
   * @param {*} results 
   * @returns
   */
  sortResultMulti (results) {
    return results = _.orderBy(
      results, 
      [
        result => {
          if (result[this.sortKey]) {
            return parseInt(result[this.sortKey], 10) * this.sortOrder;
          } else {
            return 99999;
          }
        },
        result => {
          const key = this.options.sortTarget.year;
          let value = result[key].substr(0, 4);
          return parseInt(value, 10);
        }
      ],
      ['asc', 'asc']
    );
  }
  
  sortResult(result){
  
    // 時代区分ファセット値が複数ある場合、ファセット値を古い順に並び替える
    if (this.options.multiSortValues) {
    
      let eras = this.options.sortValue.eras;
      let key = this.options.sortTarget.era;
    
      for(let i = 0, len_r = result.length; i < len_r; i++){
      
        // 時代区分ファセット値を分割し、ファセット値を時代名から順番を表す数値に置換え
        let values = result[i][key].split(',');
        let len_v = values.length;
        for(let j = 0; j < len_v; j++){
          values[j] = values[j].replace(/^[\n\r\s]/, '');
          values[j] = eras[ values[j] ];
        }
      
        // 昇順に並び替え
        values.sort( (a, b) => {
          if( a < b ) return -1;
          if( a > b ) return 1;
          return 0;
        } );
      
        // 再度、時代名に戻す
        for(let j = 0; j < len_v; j++){
          values[j] = Object.keys(eras).filter( (k) => {
            return eras[k] === values[j];
          });
        }
      
        result[i][key] = values.join(', ');
      
      }
    
    }
  
    result = _.sortBy(result, (r) => {
    
      // 50音順
      if (this.sortKey === 'kana') {
        return r[ this.options.sortTarget.kana ];
      }
    
      // 時代順
      else if(this.sortKey === 'era') {
      
        let eras = this.options.sortValue.eras;
        let key = this.options.sortTarget.era;
      
        // 複数の時代に該当する場合、最も古い時代を対象とする
        let value = r[key].split(',')[0];
      
        if (!eras[value]){
          return 1000;
        }
      
        return eras[value] * this.sortOrder;
      }
      else if (this.sortKey === 'year') {
        const key = this.options.sortTarget.year;
        let value = r[key].substr(0, 4);
        return parseInt(value, 10);
      }
      //墳丘長順
      else if (this.sortKey === 'mound'){
        let key = this.options.sortTarget.mound;
        let value = r[key].match(/\d+/);
        if (!value){
          return 1000;
        }
        return parseInt(value[0], 10) * this.sortOrder;
      }
      else if(this.sortKey === 'length') {
        var l = r['平均体長' + '(cm)'];
        if(!l || l === '未定義'){
          return 10000;
        }
        return parseInt(l, 10);
      }
      // 埴輪編年順
      else if (this.sortKey === 'haniwa_era') {
        let eras = this.options.sortValue.haniwa_eras;
        let key = this.options.sortTarget.haniwa_era;
        let value = r[key];
        if (!eras[value]){
          return 1000;
        }
        return eras[value] * this.sortOrder;
      }
      // [HZ-276] ミュシャ作品検索ツール 特集パネルからの展示トピック検索専用: 展示順に並び替え
      else if ( /topic/.test(this.sortKey) ) {
        if (r[this.sortKey]) {
          return parseInt(r[this.sortKey], 10) * this.sortOrder;
        } else {
          return 99999;
        }
      }
    });
    
    return result;
    
  }
  
  /**
   * ファセット検索システムの形式からマップシステムへマッピング
   * 
   * TODO: この定義をオプションで指定できれば汎用的に使える 
   * 
   * @param {FacetResultItem} place
   * @return {Place}
   */
  convertFromFacetResultItem(data) {
    const rowData = Object.assign({}, data);
    let placeType = data[this.options.placeTypeFacetName];
    let index = placeType.indexOf(' ');
    if (index !== -1 && this.options.enableDividePlaceTypeBySpace) {
      data[this.options.placeTypeFacetName] = placeType.substring(0, index);
    }

    return {
      lat: parseFloat(data[ this.options.mappingItems.lat ]),
      lng: parseFloat(data[ this.options.mappingItems.lng ]),
      image: data[ this.options.mappingItems.image ],
      image_label: data[ this.options.mappingItems.image_label ],
      name: data[ this.options.mappingItems.name ],
      address: data[ this.options.mappingItems.address ],
      id: parseInt(data.id, 10),
      attributes: rowData,
      type: this.getPlaceTypeFromFacetResultItem(data),
      description: data[ this.options.mappingItems.description ],
      info: data[ this.options.mappingItems.data ]
    };
  }
  /**
   * ファセット検索結果から、施設種別IDを得る
   * 
   * @param {FacetResultItem} data
   */
  getPlaceTypeFromFacetResultItem(data) {
    return this.facility_type_name_table_inverted[ data[this.options.placeTypeFacetName] ];
  }

  getPlaceTypeFacet() {
    return _.find(this.facets, {name: this.options.placeTypeFacetName});
  }
  
  /**
   * ファセット値の名称からファセット値IDを取得する
   * @param facetValues
   * @returns {Array} ids
   */
  getFacetValueIdsByName (facetValues) {
    const len = facetValues.length;
    let ids = [];
    for (let i = 0; i < len; i++) {
      ids[i] = _.find( this.getPlaceTypes(), {name: facetValues[i]} ).id;
    }
    return ids;
  }
  /**
   * 
   * setOptionsForPlaceTypesに渡す値を取得する
   */
  getPlaceTypes() {
    var types = _.flatten(this.facets.map((facet) => {
      return facet.items.map((item, i) => {
        i = i % 14;
        return {
          type_facet: facet.name === this.options.placeTypeFacetName,
          name: item.name,
          kana_search: false,
          visible: true,
          checked: false,
          help: false,
          icon_pin: i + '_pin.png',
          icon_min: i + '_min.png',
          id: item.id,
          category: facet
        }
      });
    }));
  
    // 初期値テスト
    var type = _.find(types, (t) => {
      return t.name ===  this.options.firstSelection;
    });
    if (type){
      type.checked = true;
    }
    
    return types;

  }
  
}



// WEBPACK FOOTER //
// ./map/js/ih/repository/FacetRepository.js